import { type DropdownFilterItemContent, TextBase } from '@carboncopyco/ui';
import classNames from 'classnames';
import React from 'react';

type MultiDropdownFilterItemProps = {
  checked: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  item: DropdownFilterItemContent<string>;
  isDisabled?: boolean;
};

export const MultiDropdownRenderItem = React.forwardRef<
  HTMLDivElement,
  MultiDropdownFilterItemProps
>(
  (
    { checked, onChange, item, isDisabled }: MultiDropdownFilterItemProps,
    ref
  ) => (
    <div
      ref={ref}
      className="px-2 h-9 cursor-pointer flex items-center w-full gap-2 focus:bg-ds-natural-50 focus:outline-none focus:rounded-md min-w-[283px]"
    >
      <div className="flex items-center gap-3">
        <input
          checked={checked}
          onChange={onChange}
          type="checkbox"
          className={classNames(
            `rounded-sm
                border
                outline-none
                active:outline-none
                active:ring-0
                active:ring-offset-0
                focus:outline-none
                focus:ring-0
                focus:ring-offset-0
                text-ds-primary
                cursor-pointer`,
            checked
              ? 'hover:text-ds-primary-400 active:text-ds-primary-500'
              : `border-ds-natural-200
               hover:border-ds-primary-400
               active:border-ds-primary-500`
          )}
          disabled={isDisabled}
        />
        <div className="flex items-center gap-2">
          <TextBase
            color="text-ds-natural-600"
            label={item.label}
            ellipsis
          />
        </div>
      </div>
    </div>
  )
);

MultiDropdownRenderItem.displayName = 'MultiDropdownFilterItem';
